import React from 'react';

import { liteClient as algoliasearch } from 'algoliasearch/lite';
import { Configure, connectStats, InstantSearch, Pagination, SearchBox } from 'react-instantsearch-dom';

import { AlgoliaHospitalRecord, StatsProvided } from '~/types/algolia';

import { SelectHospital } from './select-hospital';

const applicationId = 'YM74CSB9WB';
const searchOnlyAPIKey = 'dd43bdf6a8e761cb2d8ec33ab9490100';

const searchClient = algoliasearch(applicationId, searchOnlyAPIKey);

const Stats = connectStats<StatsProvided & { stateIcon: string; foundIn: string; cityName: string }>(
  ({ nbHits, stateIcon, foundIn, cityName }) => {
    const sortItems = [
      {
        value: 'prod_hospitals_by_need_desc',
        label: 'Hospital Need',
      },
    ];
    if (cityName) {
      sortItems.unshift({
        value: 'prod_hospitals',
        label: `Close to ${cityName}`,
      });
    }
    return (
      <div className='mx-auto my-8 flex items-center justify-center gap-x-6 md:my-12'>
        <div className='bg-yellow flex h-24 w-24 shrink-0 items-center justify-center rounded-full p-5 md:h-60 md:w-60 md:p-10'>
          <svg className='fill-white' fill='none' focusable='false' role='img' xmlns='http://www.w3.org/2000/svg'>
            <use xlinkHref={`#${stateIcon}`} />
          </svg>
        </div>
        <div>
          <div className='font-greycliff-extrabold text-foreground text-center leading-5 md:text-2xl'>
            <strong className='text-yellow block text-7xl'>{nbHits}</strong>
            {nbHits === 1 ? 'hospital' : 'hospitals'} found in {foundIn}
          </div>
        </div>
      </div>
    );
  },
);

interface HospitalListing {
  searchMethod: 'city' | 'hospital';
  selectedCity: any;
  selectedHospital: AlgoliaHospitalRecord | null;
  onSelectHospital: (hospital: AlgoliaHospitalRecord | null) => void;
  variant?: 'form' | 'search';
}

export function HospitalListing({
  searchMethod,
  selectedCity,
  selectedHospital,
  onSelectHospital,
  variant = 'form',
}: HospitalListing) {
  const [searchQuery, setSearchQuery] = React.useState<string | null>(null);

  const selectedCityName = selectedCity && selectedCity.name ? selectedCity.name.replace(/\s/g, '') : null;
  const stateIcon =
    selectedCity && selectedCity.administrative ? selectedCity.administrative.replace(/\s/g, '') : selectedCityName;
  const showResults = (searchMethod === 'city' && selectedCity) || (searchMethod === 'hospital' && searchQuery);

  return (
    <InstantSearch indexName='prod_hospitals' searchClient={searchClient}>
      {searchMethod === 'hospital' && (
        <SearchBox
          autoFocus={true}
          onChange={(e) => setSearchQuery(e.currentTarget.value)}
          onReset={() => setSearchQuery(null)}
          translations={{
            placeholder: 'Hospital name',
          }}
        />
      )}
      {searchMethod === 'city' && selectedCity && (
        <>
          <Stats
            cityName={selectedCity.name}
            foundIn={selectedCity.administrative ? selectedCity.administrative : selectedCity.name}
            stateIcon={stateIcon}
          />
          <Configure
            aroundLatLng={`${selectedCity.latlng.lat}, ${selectedCity.latlng.lng}`}
            filters={`state:"${selectedCity.administrative ? selectedCity.administrative : selectedCity.name}"`}
            // aroundRadius={8 * 1000}
            hitsPerPage={8}
          />
        </>
      )}
      {showResults && (
        <>
          <SelectHospital onSelectHospital={onSelectHospital} selectedHospital={selectedHospital} variant={variant} />
          <Pagination />
        </>
      )}
      <Configure hitsPerPage={8} />
    </InstantSearch>
  );
}
